/**
 * Collapses Swagger UI documented Responses examples by default.
 * Live Execute results stay visible. After Execute, the spec table is collapsed again.
 * Instruction used: scope-discipline.instructions.md
 */

const COLLAPSED_CLASS = 'helia-doc-responses-collapsed'
const BOUND = 'heliaResponsesBound'
const PREFER_COLLAPSED = 'heliaPreferCollapsed'
const COLLAPSED_AFTER_EXECUTE = 'heliaCollapsedAfterExecute'
const OBSERVER = 'heliaResponsesObserver'

export function startDocumentedResponsesCollapse(root) {
  if (!root) return
  bindDocumentedResponsesCollapse(root)
  if (root.dataset[OBSERVER] === 'true') return
  root.dataset[OBSERVER] = 'true'
  const observer = new MutationObserver(() => bindDocumentedResponsesCollapse(root))
  observer.observe(root, { childList: true, subtree: true })
}

export function bindDocumentedResponsesCollapse(root) {
  if (!root) return
  const wrappers = root.querySelectorAll('.responses-wrapper')
  for (let i = 0; i < wrappers.length; i++) {
    enhanceWrapper(wrappers[i])
  }
}

function enhanceWrapper(wrapper) {
  const hasLive = !!wrapper.querySelector('.live-responses-table')
  if (hasLive && wrapper.dataset[COLLAPSED_AFTER_EXECUTE] !== 'true') {
    wrapper.classList.add(COLLAPSED_CLASS)
    wrapper.dataset[PREFER_COLLAPSED] = 'true'
    wrapper.dataset[COLLAPSED_AFTER_EXECUTE] = 'true'
  }
  if (!hasLive) {
    wrapper.dataset[COLLAPSED_AFTER_EXECUTE] = 'false'
  }

  if (wrapper.dataset[BOUND] === 'true') {
    syncHeaderState(wrapper)
    return
  }

  wrapper.dataset[BOUND] = 'true'
  wrapper.dataset[PREFER_COLLAPSED] = 'true'
  wrapper.classList.add(COLLAPSED_CLASS)

  const header = wrapper.querySelector('.opblock-section-header')
  if (header) {
    const toggle = function (event) {
      if (event.target.closest && event.target.closest('select, input, button, label')) return
      const collapsed = !wrapper.classList.contains(COLLAPSED_CLASS)
      wrapper.classList.toggle(COLLAPSED_CLASS, collapsed)
      wrapper.dataset[PREFER_COLLAPSED] = collapsed ? 'true' : 'false'
      syncHeaderState(wrapper)
    }
    header.setAttribute('role', 'button')
    header.setAttribute('tabindex', '0')
    header.addEventListener('click', toggle)
    header.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        toggle(event)
      }
    })
  }
  syncHeaderState(wrapper)
}

function syncHeaderState(wrapper) {
  const header = wrapper.querySelector('.opblock-section-header')
  if (!header) return
  const collapsed = wrapper.classList.contains(COLLAPSED_CLASS)
  header.setAttribute('aria-expanded', collapsed ? 'false' : 'true')
}
